<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/courseList' }"
          >自有课程</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ breadcrumbItem }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box" v-if="step == 1">
          <h4 class="panel-title" >课包基本信息</h4>
          <div class="panel-content">
            <el-form :inline="true" :model="formPkg" label-width="100px">
              <el-form-item label="课包名称:">
                <el-input v-model="formPkg.name"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="级别:">
                <el-select
                  v-model="formPkg.level"
                  clearable
                  style="width: 185px"
                  @change="levelChgHandle"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="封面:">
                <el-row type="flex" class="row-bg" style="width: 200px">
                  <el-col :span="12" v-if="formPkg.image != ''">
                    <img :src="formPkg.image" width="80px" height="80px" />
                  </el-col>
                  <el-col :span="12">
                    <Upload
                      action="/aries-api/resource/upload"
                      accept="image/jpeg, image/gif, image/png"
                      :before-upload="onBeforeUpload"
                      :on-success="onSuccessUploadPkgImage"
                      :data="uploadData"
                      :show-upload-list="false"
                    >
                      <el-button size="small" type="primary">
                        上传
                        <i class="el-icon-upload el-icon--right"></i>
                      </el-button>
                    </Upload>
                  </el-col>
                  <el-col :span="3" v-if="formPkg.image != ''">
                      <el-button size="mini" type="danger" @click="delFrontCover">
                        删除
                        <i class="el-icon-delete"></i>
                      </el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <br />
              <el-form-item label="周期:">
                <el-select
                  v-model="formPkg.period"
                  clearable
                  style="width: 185px"
                >
                  <el-option
                    v-for="item in periodList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量:">
                <el-input v-model="formPkg.count"></el-input>
              </el-form-item>
              <br />
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formPkg.remark"
                  type="textarea"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="panel-box" v-else-if="step == 2">
          <h3 class="panel-title">课包编课</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formClass" label-width="90px">
              <el-form-item label="展示顺序：">
                <el-input
                  v-model="formClass.period"
                  placeholder="请输入阿拉伯数字搜索"
                ></el-input>
              </el-form-item>
              <el-form-item label="级别:">
                <el-select
                  v-model="formClass.level"
                  clearable
                  style="width: 175px"
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="名称：">
                <el-input v-model="formClass.name"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="search" @click="onQuery"
                  >搜索</el-button
                >
              </el-form-item>
              <el-form-item style="float: right">
                <el-button
                  type="primary"
                  icon="plus"
                  @click="addNewPeriod"
                  :loading="addPeriodStatus"
                  >新建一{{ periodTxt }}</el-button
                >
              </el-form-item>
            </el-form>
            <div>
              <el-table
                ref="multipleTable"
                :data="queryData"
                stripe
                border
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="id" label="ID" align="center" width="80">
                  <template slot-scope="scope">
                    <a
                      href="javascript:;"
                      @click="viewAlbum(scope.row.albumId, scope.row)"
                      style="color: #1d90e6"
                      >{{ scope.row.id }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="order"
                  label="展示顺序"
                  align="center"
                  width="100"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.order + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="level"
                  label="级别"
                  align="center"
                  width="100"
                >
                  <!-- <template slot-scope="scope">
                    <span v-if="scope.row.level">{{scope.row.level}}</span>
                    <span v-else-if="formPkg.level">{{ formPkg.level }}</span>
                  </template> -->
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="名称"
                  align="center"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <a
                      href="javascript:;"
                      @click="viewAlbum(scope.row.albumId, scope.row)"
                      style="color: #1d90e6"
                      >{{ scope.row.name }}</a
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="image"
                  label="图片"
                  align="center"
                  min-width="100"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.image"
                      min-width="70"
                      :height="scope.row.image != '' ? 70 : 20"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="count"
                  label="内容数量"
                  align="center"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="enabled"
                  label="状态"
                  align="center"
                  width="85"
                >
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.enabled" type="success"
                      >已上架</el-tag
                    >
                    <el-tag v-else type="danger">已下架</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="updated_at"
                  label="课程更新时间"
                  align="center"
                  width="150"
                >
                  <!-- <template slot-scope="scope">
                    <div class="btnFlex">
                      <span style="padding-right: 10px">{{
                        scope.row.updated_at
                      }}</span>
                      <stUpdated @stUpdatedResult="editstUpdated"></stUpdated>
                    </div>
                  </template> -->
                </el-table-column>
                <el-table-column
                  label="操作"
                  show-overflow-tooltip
                  align="center"
                  width="180"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <div class="btnFlex">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="addBasciInfo(scope.$index)"
                        style="margin-right: 5px"
                        >基本信息</el-button
                      >
                      <courseAddBook
                        :index="scope.$index"
                        @choseResult="multyaddBooks"
                      />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                type="danger"
                @click="delCourse"
                icon="delete2"
                style="margin-top: 20px"
                >删除</el-button
              >
              <el-button
                type="primary"
                @click="shangxiajia(true)"
                icon="arrow-up"
                style="margin-top: 20px"
                >上架</el-button
              >
              <el-button
                type="info"
                @click="shangxiajia(false)"
                icon="arrow-down"
                style="margin-top: 20px"
                >下架</el-button
              >
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="queryParams.page"
                  :page-sizes="[20, 50, 100]"
                  :page-size="queryParams.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pageTotal"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <div v-if="step == 1">
        <el-button
          type="primary"
          style="margin-left: 45%; margin-top: 10px; margin-bottom: 50px"
          @click="nextStep"
          >下一步</el-button
        >
        <el-button @click="cancelEdit">取消</el-button>
      </div>
      <div v-else-if="step == 2">
        <el-button
          type="primary"
          style="margin-left: 45%; margin-top: 10px; margin-bottom: 50px"
          @click="confirmSubmit"
          >完成</el-button
        >
        <el-button @click="lastStep">上一步</el-button>
      </div>
    </div>
    <Modal
      v-model="modalShow"
      width="760"
      @on-ok="modalConfirm"
      @on-cancel="modalCancel"
    >
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>课程信息</span>
      </p>
      <div>
        <el-form :inline="true" :model="formBasicInfo" label-width="90px">
          <el-form-item label="课程名称:">
            <el-input v-model="formBasicInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="级别:">
            <el-select
              v-model="formBasicInfo.level"
              clearable
              style="width: 175px"
            >
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item label="展示顺序:">
            <el-input v-model="formBasicInfo.order"></el-input>
          </el-form-item>
          <br />
          <el-form-item label="课程图片: ">
            <el-row type="flex" class="row-bg">
              <el-col :span="12" v-if="formBasicInfo.image != ''">
                <img :src="formBasicInfo.image" width="80px" height="80px" />
              </el-col>
              <el-col :span="12">
                <Upload
                  action="/aries-api/resource/upload"
                  accept="image/jpeg, image/gif, image/png"
                  :before-upload="onBeforeUpload"
                  :on-success="onSuccessUpload"
                  :data="uploadData"
                  :show-upload-list="false"
                >
                  <el-button size="small" type="primary">
                    上传
                    <i class="el-icon-upload el-icon--right"></i>
                  </el-button>
                </Upload>
              </el-col>
            </el-row>
            <p style="font-size: 10px; color: red">图片推荐尺寸64px x 64px</p>
          </el-form-item>
          <br />
          <el-form-item label="课程简介:">
            <el-input
              :rows="5"
              style="width: 600px"
              v-model="formBasicInfo.desc"
              type="textarea"
            />
          </el-form-item>
        </el-form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import { NumToChinese } from "../commonEdu";
import courseAddBook from "../componentsEdu/courseAddBook";
// import stUpdated from "./componentsEdu/stUpdated";

export default {
  name: "addCourse",
  components: { courseAddBook },
  data() {
    return {
      formPkg: {
        name: "",
        level: "",
        image: "",
        period: null,
        count: null,
        enabled: null,
        remark: "",
        image:""
      },
      periodList: [
        {
          value: 1,
          label: "日",
        },
        {
          value: 2,
          label: "周",
        },
        {
          value: 3,
          label: "月",
        },
      ],
      levelList: [
        {
          value: "初级",
          label: "初级",
        },
        {
          value: "中级",
          label: "中级",
        },
        {
          value: "高级",
          label: "高级",
        },
        {
          value: "桥梁",
          label: "桥梁",
        },
        {
          value: "初章",
          label: "初章",
        },
        {
          value: "中章",
          label: "中章",
        },
      ],
      step: 1,
      breadcrumbItem: "",
      formClass: {
        period: "",
        name: "",
      },
      queryData: [],
      periodTxt: "",
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      modalShow: false,
      modalIndex: null,
      formBasicInfo: {
        name: "",
        order: null,
        image: "",
        desc: "",
        level: "",
      },
      uploadData: {
        isOnlyMP3: "false",
        pdfToPng: "false",
      },
      bookData: [],
      currId: "",
      pkgEnabled: false,
      addPeriodStatus: false,
      backupImage: "",
      multipleSelection: [],
      statusList: [
        {
          value: 0,
          label: "注册",
        },
        {
          value: 1,
          label: "激活",
        },
        {
          value: 2,
          label: "活跃",
        },
        {
          value: 3,
          label: "到期",
        },
        {
          value: 4,
          label: "注销",
        },
      ],
    };
  },
  created() {
    if(this.$route.query.id){
      this.breadcrumbItem="编辑课包"
    }else{
      this.breadcrumbItem="新增课包"
    }
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
      };

      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_list",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res).list[0];
          this.formPkg.name = m.name;
          this.formPkg.level = m.level;
          this.backupImage = m.image;
          this.formPkg.count = m.count;
          this.formPkg.remark = m.remark;
          this.formPkg.period = m.period;
          this.pkgEnabled = m.enabled;
          this.formPkg.image = m.image
        }
      });
    }
  },
  watch: {
    step(newVal, oldVal) {
      if (newVal == 2) {
        this.breadcrumbItem = this.formPkg.name;
      } else if (newVal == 1&&!this.currId) {
        this.breadcrumbItem = "新建课包";
      }else if(newVal == 1&&this.currId!=""){
        this.breadcrumbItem = "编辑课包";
      }
    },
  },
  methods: {
    delFrontCover(){
      this.formPkg.image = ''
    },
    editstUpdated(val) {
      // debugger
      let stuId = `${this.$route.query.id}`;
      let updatedTime = val.updatedTime;
      let params = {
        appId: this.$API.APPID,
        stuId: stuId,
        updatedTime: updatedTime,
      };
      // console.log(params, 47676877);

      // this.$axios
      //   .post("/edu/eduAdmin/stu/modify_score", params)
      //   .then((response) => {
      //     if (response != null) {
      //       this.$Message.success("操作成功!");
      //       this.fetchDetail();
      //     }
      //   });
      // }
    },
    confirmSubmit() {
      this.$router.push({
        name: "courseList",
      });
    },
    cancelEdit() {
      this.$router.push({
        name: "courseList",
      });
    },
    nextStep() {
      if (this.formPkg.name == "") {
        alert("课包名称为必填项");
        return;
      }
      if (this.formPkg.period == null) {
        alert("周期为必填项");
        return;
      }
      if (this.formPkg.count == null) {
        alert("数量为必填项");
        return;
      }

      let params = {
        appId: this.$API.APPID,
        name: this.formPkg.name,
        level: this.formPkg.level,
        image: this.formPkg.image,
        period: this.formPkg.period,
        count: Number(this.formPkg.count),
        enabled: this.pkgEnabled,
        remark: this.formPkg.remark,
      };
      if (this.currId != "") {
        params.id = `${this.currId}`;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/package_save",
        params
      ).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.currId = m.id;
          if (this.formPkg.period == 1) {
            this.periodTxt = "日";
          } else if (this.formPkg.period == 2) {
            this.periodTxt = "周";
          } else if (this.formPkg.period == 3) {
            this.periodTxt = "月";
          }
          this.fetchCourseList();
        }
      });
    },
    fetchCourseList() {
      let params2 = {
        appId: this.$API.APPID,
        packageId: `${this.currId}`,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
      };
      if (this.formClass.period != "") {
        params2.order = Number(this.formClass.period) - 1;
      }
      if (this.formClass.name != "") {
        params2.name = this.formClass.name;
      }
      if (this.formClass.level != "") {
        params2.level = this.formClass.level;
      }
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/course_list",
        params2
      ).then((res2) => {
        if (res2 != null) {
          let m2 = JSON.parse(res2);
          this.queryData = m2.list;
          this.pageTotal = m2.pager.total;
          if (this.step != 2) {
            this.step = 2;
          }
          if (this.addPeriodStatus) {
            this.addPeriodStatus = false;
          }
        }
      });
    },
    lastStep() {
      this.step = 1;
    },
    onQuery() {
      this.queryParams.page = 1;
      this.fetchCourseList();
    },
    addNewPeriod() {
      if (this.queryData.length < this.formPkg.count) {
        let order = this.pageTotal;
        if (this.queryData.length > 0) {
          let maxOrder = 0;
          for (let j in this.queryData) {
            if (this.queryData[j].order > maxOrder) {
              maxOrder = this.queryData[j].order;
            }
          }
          if (maxOrder + 1 > order) {
            order = maxOrder + 1;
          }
        }
        this.addPeriodStatus = true;
        let temp = {
          appId: this.$API.APPID,
          packageId: `${this.currId}`,
          order: order,
          name: `第${NumToChinese(order + 1)}${this.periodTxt}`,
          image: `http://file.aiedevice.com/media/images/icon/edu/${
            this.$API.APPID
          }/${order + 1}w.png`,
          enabled: false,
          level: this.formPkg.level,
        };
        temp.desc = temp.name;
        this.$axios
          .post("/edu/eduAdmin/course/course_save", temp)
          .then((response) => {
            if (response.data.rc == 0) {
              // this.addPeriodStatus = false;
              this.fetchCourseList();
            } else {
              alert(response.data.err);
              this.addPeriodStatus = false;
            }
          });
      } else {
        alert("添加的数目不能大于数量限制");
      }
    },
    addBasciInfo(index) {
      // debugger
      this.modalIndex = index;
      this.modalShow = true;

      let temp = this.queryData[index];
      this.formBasicInfo.name = temp.name;
      this.formBasicInfo.order = temp.order + 1;
      this.formBasicInfo.image = temp.image;
      this.formBasicInfo.desc = temp.desc;
      if (temp.level) {
        this.formBasicInfo.level = temp.level;
      } else {
        this.formBasicInfo.level = this.formPkg.level;
      }
    },

    modalConfirm() {
      let temp = {
        appId: this.$API.APPID,
      };
      if (this.modalIndex != null) {
        temp = Object.assign({}, temp, this.queryData[this.modalIndex]);
      }
      /*
      else {
        temp.packageId = `${this.currId}`;
        temp.order = this.queryData.length;
        temp.enabled = false;
      }
      */

      if (Number(this.formBasicInfo.order) <= 0) {
        alert("展示顺序必须大于0");
        return;
      }
      temp.name = this.formBasicInfo.name;
      if (Number(this.formBasicInfo.order) > 0) {
        temp.order = Number(this.formBasicInfo.order) - 1;
      }
      temp.image = this.formBasicInfo.image;
      temp.desc = this.formBasicInfo.desc;
      temp.level = this.formBasicInfo.level;
      this.eduAxiosPostRequest("/edu/eduAdmin/course/course_save", temp).then(
        (res) => {
          if (res != null) {
            this.fetchCourseList();
          }
        }
      );

      //else if (this.modalTitle == "添加资源") {
      //  this.fetchCourseList();
      //}
    },
    modalCancel() {
      this.modalShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delCourse() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择课");
        return;
      }

      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除所选课</li></ul>",
        onOk: () => {
          let ids = [];
          for (let i in this.multipleSelection) {
            ids.push(`${this.multipleSelection[i].id}`);
          }
          let params = {
            appId: this.$API.APPID,
            courseIdList: ids,
          };
          this.eduAxiosPostRequest(
            "/edu/eduAdmin/course/course_del",
            params
          ).then((res) => {
            if (res != null) {
              this.$Message.success("删除成功!");
              this.fetchCourseList();
            }
          });
        },
      });
    },
    shangxiajia(val) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择课");
        return;
      }
      let ids = [];
      for (let i in this.multipleSelection) {
        ids.push(`${this.multipleSelection[i].id}`);
      }
      let params2 = {
        appId: this.$API.APPID,
        courseIdList: ids,
        enabled: val,
      };
      this.eduAxiosPostRequest(
        "/edu/eduAdmin/course/course_batch",
        params2
      ).then((res) => {
        if (res != null) {
          this.contentCloudOnline(this.multipleSelection, val).then((res2) => {
            console.log(res2);
            if (res2 != null) {
              this.$Message.success("操作成功!");
              this.fetchCourseList();
            }
          });
        }
      });
    },
    contentCloudOnline(arr, val) {
      return new Promise((resolve, reject) => {
        let ids = [];
        for (let i in arr) {
          ids.push(Number(arr[i].albumId));
        }
        let params = {
          appId: this.$API.APPID,
          ids: ids,
          status: Number(val),
        };
        this.$axios
          .post("/aries-api/album/online", params)
          .then((response) => {
            console.log(response);
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.msg));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchCourseList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchCourseList();
    },

    onBeforeUpload() {
      return true;
    },
    onSuccessUpload(response, file, fileList) {
      console.log(response);
      this.formBasicInfo.image = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    onSuccessUploadPkgImage(response, file, fileList) {
      console.log(response);
      this.formPkg.image = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    multyaddBooks(params) {
      //this.handleResAdd2Server(this.multipleSelection);
      if (params != null) {
        if (params.sel.length == 0) {
          alert("请先选择数据");
          return;
        }else{
        this.handleResAdd2Server(params.index, params.sel);
        }
      } else {
        this.fetchCourseList();
      }
    },
    handleBookSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleResAdd2Server(index, arr) {
      let res = [];
      for (let i = 0; i < arr.length; ++i) {
        let tmp = {
          id: arr[i].id,
          dbId: arr[i].dbId,
        };
        res.push(tmp);
      }
      console.log(index);
      let params = {
        appId: this.$API.APPID,
        id: this.queryData[index].albumId,
        resList: res,
      };
      this.$axios
        .post("/aries-api/album/saveRes", params)
        .then((response) => {
          console.log(response);
          let m = response.data;
          if (m.result == 0) {
            this.$Message.success("添加成功!");
          } else {
            alert(response.data.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    viewHowEdit(book) {
      let routeUrl = this.$router.resolve({
        name: "addbook",
        query: {
          cpid: book.dbId,
          bookid: book.id,
          do: "view",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    viewAlbum(albumId, rows) {
      // if (rows.count == 0) {
      //   // alert("请先关联内容");
      // } else {
      let routeUrl = this.$router.resolve({
        name: "packageCourseDetail",
        query: {
          id: albumId,
          do: "edit",
        },
      });
      window.open(routeUrl.href, "_blank");
      // }
    },
    levelChgHandle(val) {
      if (this.backupImage != "") {
        this.formPkg.image = this.backupImage;
        this.backupImage = "";
      } else {
        let tmp = null;
        switch (val) {
          case "初级":
            tmp = 1;
            break;
          case "中级":
            tmp = 2;
            break;
          case "高级":
            tmp = 3;
            break;
          case "桥梁":
            tmp = 4;
            break;
          case "初章":
            tmp = 5;
            break;
          case "中章":
            tmp = 6;
            break;
          case "高章":
            tmp = 7;
            break;
          default:
            break;
        }
        this.formPkg.image = `http://file.aiedevice.com/media/images/icon/edu/${this.$API.APPID}/lv${tmp}.png`;
      }
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("course_batch") != -1 ||
                address.indexOf("course_del") != -1
              ) {
                resolve(JSON.stringify(response.data.msg));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// addCourse.vue?66ee5502